import { render, staticRenderFns } from "./DocumentDownloadsListItem.vue?vue&type=template&id=ff60bd00&"
import script from "./DocumentDownloadsListItem.vue?vue&type=script&lang=js&"
export * from "./DocumentDownloadsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports